/*eslint-disable*/
import React, { Component } from 'react'
import { Table, Input, Form as FormUi, Icon, Segment, Header, Grid, Label, Message } from 'semantic-ui-react'
import { Field, FieldArray } from 'formik'
import moment from 'moment';
import SerialNumber from '../../apiInputComponent/serialNumber'
import Axios from 'axios'
import APP_CONSTANTS from '../../../config/constants';
import JobcardSerialNo from '../../apiInputComponent/jobcardSerialNo';
import JobcardCheckboxSelect from '../../apiInputComponent/jobcardCheckboxSelect';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { MyCheckBox } from '../../apiInputComponent/myInput'
import AddSerialNoModal from './addSerialNoModal';
import AddSerialNoInput from './addSerialNoInput';
import AddTyreRunEdit from './addTyreRunEdit';


export default class TyreEdit extends Component {

  state = {
    tyrNumber: [
      { "productInvId": "", "serialNo": "", "tyreRun": "", "tyrePositionId": "", "oldSerialNo": "" }
    ],
    isupdate: false,
    oldId: this.props.vehicleInfoarray[0].vehicleId,
    maxTyreRun: 0,
    conditionData: [],
    openNewSerialNoModal: false
  }

  componentDidUpdate(prevProps) {
  }

  componentDidMount() {
    this.getConditionsData(Math.max(this.props.maxTyreRun))
  }

  getConditionsData = (runTyer) => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')
    let maxRun = runTyer
    let cardId = this.props.cardTypeId
    let vehId = this.props.vehicleIdrole
    let data = JSON.stringify
      ({
        api_token: token,
        customerNo: customerNo,
        jobCardTypeId: cardId,
        vehicleId: vehId,
        userId: userId,
        maxTyreRun: maxRun,
      })
    Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobCardApproverRole`, data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token
      }
    }).then((response => {

      if (response.data.status === 1) {
        this.setState({
          conditionData: response.data.data
        })
        let arr = []
        response.data.data.map((o) => {
          arr.push(o.roleId)
        })
        this.props.conditionRoleId(arr)
        this.props.jbConditionId(response.data.data[0])
        props.valueForApproval(maxTyreRun)

      } else {
        this.setState({
          conditionData: []
        })
        this.props.conditionRoleId([])
      }
    }))
      .catch(error => console.log(error))
  }

  openNewSerialNoModalClose = () => {
    this.setState({ openNewSerialNoModal: false })
  }

  handleSerial = (e, data) => {
    if (data) {
      const { productInventoryId, serialNo } = data.value
      let initialpoint = this.state.tyrNumber
      initialpoint[data.dataId].productInvId = productInventoryId
      initialpoint[data.dataId].serialNo = serialNo
      this.setState({
        tyrNumber: [...initialpoint],
        isupdate: true
      }, () => this.props.tyreDetails(this.state.tyrNumber))
    }
  }

  handleUpdate = () => {
    this.props.tyreDetails(this.state.tyrNumber)
  }

  render() {
    let tyresInfo = this.state.tyrNumber

    return (
      <>
        <FieldArray
          name="tyreDetails"
        >
          {({ form }) => {
            const { values, setFieldValue } = form;
console.log(values,'values')

            return (
              <Segment>
                <div className="ui form subform tiny">
                  <Table unstackable size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell className="w3-white" colSpan="6"> <label className="labelName w3-text-blue">Tyre Details</label></Table.HeaderCell>
                      </Table.Row>
                      <Table.Row >
                        <Table.HeaderCell className="labelName p-bold-600">Tyre Position</Table.HeaderCell>
                        {values.jobcardActivity == 1 ?
                          null :
                          <Table.HeaderCell className="labelName p-bold-600">Serials No</Table.HeaderCell>
                        }
                        <Table.HeaderCell className="labelName p-bold-600">Installation Date</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Tyre Run (Kms)</Table.HeaderCell>
                        {values.jobcardActivity == 2 ?
                          null :
                          <>
                            {values.jobcardActivity == 1 ? <Table.HeaderCell className="labelName p-bold-600">Serial Number</Table.HeaderCell> : values.jobcardActivity == 3 ? <Table.HeaderCell className="labelName p-bold-600">New Serial Number</Table.HeaderCell> : <Table.HeaderCell className="labelName p-bold-600">New Serial Number</Table.HeaderCell>}
                          </>
                        }
                        {values.jobcardActivity == 2 || values.jobcardActivity == 3 || values.jobcardActivity == 1 ?
                          <Table.HeaderCell className="labelName p-bold-600"> </Table.HeaderCell> :
                          null
                        }
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {values?.jobcardActivity && values.jobcardActivity == 1 ?
                        <>
                          {
                            values?.tyreDetailsFromAdd && values.tyreDetailsFromAdd.map((object, index) => {
                              return (
                                <>
                                  {console.log("{{{{{{{{{{{{{{{{{{{{{1111111111111111111111111111111)))))))))))))))))))")}
                                  {console.log(object)}
                                  {console.log(values?.tyreDetailsFromAdd)}
                                  <Table.Row key={index} verticalAlign="middle" className={object.removeJobfromList ? 'opacityBlurr' : ''}>
                                    <Table.Cell>{object.tyrePositionName}</Table.Cell>
                                    {values.jobcardActivity == 1 ?
                                      null :
                                      <Table.Cell>{object.oldSerialNo}</Table.Cell>
                                    }
                                    <Table.Cell>
                                      <>
                                        <DatePicker
                                          name={`tyreDetailsFromAdd[${index}].installationDate`}
                                          readOnly={this.props?.viewOnly ? true : false}
                                          autoComplete="off"
                                          popperClassName="dateTime"
                                          dateFormat="dd-MM-yyyy"
                                          placeholderText="Date"
                                          selected={object.installationDate}
                                          onChange={val => {
                                            setFieldValue(`tyreDetailsFromAdd[${index}].installationDate`, val);
                                            setFieldValue(`tyreDetailsFromAdd[${index}].flag`, 1);
                                          }}
                                          customInput={<Input autoComplete="off" icon="time" className="dateWidth2" iconPosition="left" />}
                                        />
                                      </>
                                    </Table.Cell>
                                    <Table.Cell>

                                      {
                                        this.props?.viewOnly ?
                                          <>
                                            {object.tyreRun}
                                          </>
                                          :
                                          <Field placeholder={object.tyreRun} name={`tyreDetailsFromAdd[${index}].tyreRun`} setFlag={`tyreDetailsFromAdd[${index}].flag`} component={AddTyreRunEdit} />
                                      }
                                    </Table.Cell>
                                    {values.jobcardActivity == 2 ?
                                      null :
                                      <>

                                        {this.props.viewMode ?
                                          <Table.Cell className='display-flex'>
                                            <Table.Cell>{object.serialNo}</Table.Cell>
                                          </Table.Cell>
                                          :
                                          <Table.Cell className='display-flex'>
                                            <Field
                                              name={`tyreDetailsFromAdd[${index}].serialNo`}
                                              showAddSrno={(values.jobcardActivity == 1 && object?.oldSerialNo?.length > 0 ? true : false) ? false : true}
                                              component={JobcardSerialNo}
                                              placeholder={values.jobcardActivity == 1 && object?.serialNo?.serialNo
                                                ?
                                                object.serialNo.serialNo
                                                :
                                                (object?.serialNo && object?.serialNo?.length > 0)
                                                  ?
                                                  object.serialNo
                                                  :
                                                  "Sr. No."
                                              }
                                              disabled={values.jobcardActivity == 1 && object?.oldSerialNo?.length > 0 ? true : false}
                                              typeOfActivity={values.jobcardActivity}
                                              addNewSerialNoPassed={object.oldSerialNo}
                                              oldMapIdPassed={object.oldTyreMapId}
                                              setFlag={`tyreDetailsFromAdd[${index}].flag`}
                                              modeCheck="new"
                                              dataId={index}
                                              TyreId="1"
                                              isAvailable="1" />
                                          </Table.Cell>
                                        }
                                      </>
                                    }
                                    {
                                      this.props?.viewOnly ? null :
                                        <Table.Cell>
                                          <Icon name='trash' className='mt-10' color="red" onClick={(e) => { e.stopPropagation(); setFieldValue(`tyreDetailsFromAdd[${index}].removeJobfromList`, object.removeJobfromList == 0 ? 1 : 0) }} />
                                        </Table.Cell>
                                    }

                                  </Table.Row>
                                </>
                              )

                            })
                          }
                        </>
                        :
                        <>
                          {
                            values.tyreDetails.map((object, index) => {
                              return (
                                <>
                                  <Table.Row key={index} verticalAlign="middle" className={object.removeJobfromList ? 'opacityBlurr' : ''}>
                                    <Table.Cell>{object.tyrePositionName}</Table.Cell>
                                    {values.jobcardActivity == 1 ?
                                      null :
                                      <Table.Cell>{object.oldSerialNo}</Table.Cell>
                                    }
                                    <Table.Cell>
                                      <DatePicker
                                        name={`tyreDetails[${index}].installationDate`}
                                        readOnly={this.props?.viewOnly ? true : false}
                                        autoComplete="off"
                                        popperClassName="dateTime"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Date"
                                        selected={object.installationDate}
                                        onChange={val => {
                                          setFieldValue(`tyreDetails[${index}].installationDate`, val);
                                          setFieldValue(`tyreDetails[${index}].flag`, 1);
                                        }}
                                        customInput={<Input autoComplete="off" icon="time" className="dateWidth2" iconPosition="left" />}
                                      />
                                    </Table.Cell>
                                    <Table.Cell>
                                      {
                                        this.props?.viewOnly || values.jobcardActivity == 2 ?
                                          <>
                                            {object.tyreRun}
                                          </>
                                          :
                                          <Field name={`tyreDetails[${index}].tyreRun`} placeholder={object?.tyreRun ? +object.tyreRun : "Enter Tyre Run.."} setFlag={`tyreDetails[${index}].flag`} component={AddTyreRunEdit} />
                                      }
                                    </Table.Cell>
                                    {values.jobcardActivity == 2 ?
                                      null :
                                      <>

                                        {this.props.viewMode ?

                                          <Table.Cell className='display-flex'>
                                            {object.serialNo}
                                          </Table.Cell>
                                          :
                                          <Table.Cell className='display-flex'>
                                            <Field
                                              name={`tyreDetails[${index}].serialNo`}
                                              component={JobcardSerialNo}
                                              showAddSrno={true}
                                              placeholder={object.serialNo}
                                              //disabled={values.jobcardActivity == 1 && object?.oldSerialNo?.length > 0 ? true : false}
                                              typeOfActivity={values.jobcardActivity}
                                              addNewSerialNoPassed={object.oldSerialNo}
                                              oldMapIdPassed={object.oldTyreMapId}
                                              setFlag={`tyreDetails[${index}].flag`}
                                              dataId={index}
                                              modeCheck="new"
                                              TyreId="1"
                                              isAvailable="1" />
                                          </Table.Cell>
                                        }
                                      </>
                                    }
                                    {values.jobcardActivity == 2 ?
                                      <>
                                        {
                                          this.props?.viewOnly ? null :
                                            <Table.Cell>
                                              <Field
                                                name={`tyreDetails[${index}].checkboxSelect`}
                                                component={JobcardCheckboxSelect}
                                                setFlag={`tyreDetailsFromAdd[${index}].flag`}
                                                checked={object.checkboxSelect}
                                              />
                                            </Table.Cell>
                                        }
                                      </> :
                                      <>
                                        {
                                          this.props?.viewOnly ? null :
                                            <Table.Cell>
                                              <Icon name='trash' className='mt-10' color="red" onClick={(e) => { e.stopPropagation(); setFieldValue(`tyreDetails[${index}].removeJobfromList`, object.removeJobfromList == 0 ? 1 : 0) }} />
                                            </Table.Cell>
                                        }
                                      </>
                                    }

                                  </Table.Row>
                                </>
                              )

                            })
                          }
                        </>}

                    </Table.Body>
                  </Table>
                  {this.state.conditionData.length > 0 ?
                    this.state.conditionData.map((object, i) => (
                      <>
                        <Message size="tiny" info icon>
                          <Message.Content>
                            <p>
                              Approver: <b>{object.roleName} </b>
                              Distance: <b>{object.endValue} KMs</b>
                            </p>
                          </Message.Content>
                        </Message>
                      </>
                    ))
                    : ''
                  }
                </div>
              </Segment>

            )
          }}
        </FieldArray>
      </>
    )
  }
}
